import Image from "@/components/Image/image";

import styles from "./card-image.module.scss";
import classnames from "classnames";
import { CardImageStoryblok } from "@/types/component-types-sb";

interface Props {
  blok: CardImageStoryblok;
}

const CardImage = (props: Props) => {
  return (
    <div className={styles.wrapper}>
      <div>
        <Image
          className={styles.img}
          filename={props.blok.image.filename}
          alt={props.blok.image.alt}
          focus={props.blok.image.focus}
          aspectMobile={"1/1"}
          priority
        />
      </div>
      <div className={styles.textContentWrapper}>
        <div className={classnames(styles.header, styles.mt40)}>
          {props.blok.header}
        </div>
        <div className={styles.mt16}>{props.blok.text}</div>
      </div>
    </div>
  );
};

export default CardImage;
